import Yup from 'utils/yup'

export const defaultValues = {
  email: null,
  login: null,
  code: null,
  newPassword: null,
  confirmNewPassword: null,
}

export const validationSchema = Yup.object().shape({
  email: Yup.string().nullable().required().email('E-mail inválido').max(40, 'O email deve ter no máximo 40 caracteres'),
  login: Yup.string().nullable().required().min(5, 'O login deve ter no mínimo 5 caracteres').max(20, 'O login deve ter no máximo 20 caracteres'),
  code: Yup.string().nullable().required(),
  newPassword: Yup.string()
    .nullable()
    .required()
    .min(6, 'A senha deve ter no mínimo 6 caracteres')
    .max(20, 'A senha deve ter no máximo 20 caracteres')
    .test('passwords-match', 'A confirmação de senha está incorreta', function (value) {
      return this.parent.confirmNewPassword === value
    }),
  confirmNewPassword: Yup.string()
    .nullable()
    .required()
    .min(6, 'A senha deve ter no mínimo 6 caracteres')
    .max(20, 'A senha deve ter no máximo 20 caracteres')
    .test('passwords-match', 'A confirmação de senha está incorreta', function (value) {
      return this.parent.newPassword === value
    }),
})
